import React from "react";

const I = ({ status }) => {
  return (
    <i
      className={
        status ? "fa fa-check fa-lg success" : "fa fa-times fa-lg error"
      }
    />
  );
};

export default I;
